// extracted by mini-css-extract-plugin
module.exports = {"rightArrow":"styles_rightArrow__mE1Cq"};